import { Checkbox, Tooltip } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomImage from '../CustomImage/CustomImage';
import TableBuilder from '../../TableBuilder/TableBuilder';
import { useDispatch, useSelector } from 'react-redux';
import { addImageAsync, deleteImageAsync, fetchImages, updateImageAsync } from '../../../slices/imagesSlice';
import { useNotification } from '../../../Helper/NotificationProvider';

const ESLImages = (props) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState("Copy URL");
  const [visibleTooltipIndex, setVisibleTooltipIndex] = useState(null);
  const { openNotification } = useNotification();
  const searchableColumns = ['filename'];
  const sortableColumns = ['createdAt'];
  const columnColors = [{ columnName: 'firstName', color: 'primary-color' }];
  const loading = useSelector(state => state.images.loading);
  const dispatch = useDispatch();

  const copyToClipboard = (url, index) => {
    navigator.clipboard.writeText(url).then(() => {
      setTitle("Copied!");
      setVisibleTooltipIndex(index);
      setTimeout(() => {
        setVisibleTooltipIndex(null);
        setTitle("Copy URL!");
      }, 1000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: 'filename',
      key: 'filename',
      editable: true,
      render: (text, record) => (
        <div>
          <strong>{text}</strong>
        </div>
      ),
    },
    {
      title: t("Link"),
      dataIndex: "url",
      key: "url",
      render: (text, record, index) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <a href={text} target="_blank" rel="noopener noreferrer">{text.substring(0,80)}...</a>
          <Tooltip title={title} visible={visibleTooltipIndex === index ? true : undefined}>
            <CopyOutlined
              className="icon-btn-small"
              onClick={() => copyToClipboard(text, index)}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: t("Hochgeladen"),
      dataIndex: "createdAt",
      key: "createdAt",
    },
    {
      title: t("Vorschau"),
      dataIndex: "preview",
      key: "preview",
      render: (text, record) => (
        <CustomImage
          width={50}
          link={record.url}
        />
      ),
    }
  ];

  const handleOnSelectionChange = (selectedRowKeys, selectedRows) =>{
    props.setSelectedRowKeys(selectedRowKeys);
    props.setSelectedRows(selectedRows)
  }

  const handleEditImage = async (key, row) => {
    try {
      const resultAction = await dispatch(updateImageAsync({ imageId: key, updatedData: row }));
      if (updateImageAsync.fulfilled.match(resultAction)) {
        openNotification(
          'bottomRight',
          'Erfolg',
          'Bild erfolgreich hochgeladen.',
          true
        );
      } else {
        openNotification(
          'bottomRight',
          'Fehler',
          'Update des Bildes fehlgeschlagen.',
          false
        );
      }
    } catch (error) {
      console.error('Error updating image:', error);
      openNotification(
        'bottomRight',
        'Fehler',
        'Ein unerwarteter Fehler ist beim Aktualisieren des Bildes aufgetreten.',
        false
      );
    }
  };


  const handleDeleteImage = async (key, blobId) => {
    try {
      const resultAction = await dispatch(deleteImageAsync(blobId));

      if(addImageAsync.rejected.match(resultAction)) {
        openNotification(
          'bottomRight',
          "Fehler",
          'Das Bild konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
          false
        );
      } else {
        openNotification(
          'bottomRight',
          "Gelöscht",
          'Bild wurde gelöscht.',
          true
        );
        dispatch(fetchImages());
      }
    } catch (error) {
      console.error('Error deleting images:', error);
      openNotification(
        'bottomRight',
        "Fehler",
        'Fehler beim Löschen des Bildes. Bitte versuchen Sie es erneut.',
        false
      );
    }
  };

  return (
    <TableBuilder
      title={'Bilder'}
      data={props.data}
      columns={columns}
      searchableColumns={searchableColumns}
      sortableColumns={sortableColumns}
      columnColors={columnColors}
      typfilter={[]}
      expandable={false}
      loading={loading}
      multipleSelect={true}
      handleSave={handleEditImage}
      handleDelete={handleDeleteImage}
      onSelectionChange={handleOnSelectionChange}
    />
  );
}

export default ESLImages;
